import Tracker from "./tracker.js";
import ValueTracker from "./value-tracker.js";
import ObjectValueTrackerLinker from "./obj-value-track-linker.js";

class SinglePropTracker extends Tracker {
    constructor(userdata) {
        super();

        this._tracker = new ValueTracker(userdata);
        this._linker = new ObjectValueTrackerLinker(this._tracker);

        this._tracker.listenNeedsUpdate(() => this.protected_needsUpdate());
    }

    track(newObject, newEvents, newKey) {
        this._linker.track(newObject, newEvents, newKey);
    }

    protected_startUpdate() {
        return this._tracker.startUpdate();
    }

    protected_finishUpdate() {
        this._tracker.finishUpdate();
    }
}

export default SinglePropTracker;
